import NavigableValidation from "./navigableValidation";
import WorkflowStep from "../../../formability/form_builder/models/workflow/workflowStep";
import WorkflowStepViewerValidator from "../navigableValidators/workflowStepDataViewerValidator";
import WorkflowStepCompleterValidator from "../navigableValidators/workflowStepCompleterValidator";
import WorkflowStepStatusValidator from "../navigableValidators/workflowStepStatusValidator";
import EmbeddedCollectionValidator from "../navigableValidators/embeddedCollectionValidator";
import WorkflowStepStatusViewerValidator from "../navigableValidators/workflowStepStatusViewerValidator";
import FormSectionValidator from "~/models/navigableValidators/formSectionValidator";
import {ValidationModalSection} from "~/models/navigableValidations/validationSections";
import PrePopulationValidator from "../navigableValidators/prePopulationValidator";

export default class WorkflowStepValidation<T> extends NavigableValidation<WorkflowStep> {
  constructor(options){
    super(options);
    this.validators = [
      new FormSectionValidator({
        validatorKey: 'form_section',
        section: ValidationModalSection.Layout
      }, this.model),
      new PrePopulationValidator({
        validatorKey: "process_flow",
        section: ValidationModalSection.Workflow,
        anchorHash: 'process-flow-search'
      }),
      new WorkflowStepViewerValidator({
        section: ValidationModalSection.Workflow
      }),
      new WorkflowStepCompleterValidator({
        section: ValidationModalSection.Workflow
      }),
      new WorkflowStepStatusViewerValidator({
        section: ValidationModalSection.Workflow,
        anchorHash: 'status-viewer'
      }),
      new WorkflowStepStatusValidator({
        section: ValidationModalSection.Workflow,
        anchorHash: 'status'
      }),
      new EmbeddedCollectionValidator({
        validatorKey: 'actions',
        section: ValidationModalSection.Workflow
      }, this.model),
    ]
  }

  protected buildQuery(validatorKey, workflowStep) {
    return workflowStep ? {stepId: workflowStep.client_id} : {}
  }
}
